var _ellipse, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManualCreateOption4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_80_1",
    "data-name": "Component 80 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 21,
    cy: 21,
    rx: 21,
    ry: 21,
    fill: "#d8d2ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-exam-4519168",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3559",
    "data-name": "Group 3559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17663",
    "data-name": "Path 17663",
    d: "M74.391,41.4v6.279a5.374,5.374,0,0,1,0,.767c-.073.365-.219.438-.438.438-.73.037-1.5,0-2.227,0H60.812c-.548,0-.913.11-.949-.584-.037-1.57,0-3.139,0-4.746V35.338c0-1.5-.11-3.03,0-4.527.037-.767.438-.621,1.022-.621H71.836c.694,0,1.424-.037,2.154,0,.256,0,.4.11.438.438a9.267,9.267,0,0,1,0,1.424V33.44a.877.877,0,0,0,1.752,0V31.907a9.389,9.389,0,0,0-.073-1.752,2.212,2.212,0,0,0-2.044-1.789H66.032c-1.935,0-3.906-.073-5.841,0a2.442,2.442,0,0,0-2.081,2.665V48.3a2.257,2.257,0,0,0,2.081,2.336c.548.037,1.132,0,1.679,0H73.953a2.059,2.059,0,0,0,1.862-1.241,7.906,7.906,0,0,0,.256-3.212c.11-1.314.11-2.665.11-3.979v-.767a.9.9,0,0,0-1.789-.037Z",
    transform: "translate(-58.11 -28.333)",
    fill: "#3208ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17664",
    "data-name": "Path 17664",
    d: "M204.113,219.325a.913.913,0,0,0,0-1.825H194a.913.913,0,0,0,0,1.825h10.112Z",
    transform: "translate(-190.497 -213.817)",
    fill: "#3208ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17665",
    "data-name": "Path 17665",
    d: "M192.126,894.325h10.112a.913.913,0,0,0,0-1.825H192.126A.913.913,0,0,0,192.126,894.325Z",
    transform: "translate(-188.658 -875.676)",
    fill: "#3208ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17666",
    "data-name": "Path 17666",
    d: "M195.372,423.75h-5.184a.9.9,0,0,0-.913.913.927.927,0,0,0,.913.913h5.184a.9.9,0,0,0,.913-.913A.927.927,0,0,0,195.372,423.75Z",
    transform: "translate(-186.72 -416.052)",
    fill: "#3208ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17667",
    "data-name": "Path 17667",
    d: "M190.188,650.575h5.184a.9.9,0,0,0,.913-.913.927.927,0,0,0-.913-.913h-5.184a.9.9,0,0,0-.913.913A.927.927,0,0,0,190.188,650.575Z",
    transform: "translate(-186.72 -636.671)",
    fill: "#3208ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17668",
    "data-name": "Path 17668",
    d: "M657.484,338.448l-.365-.621a1.526,1.526,0,0,0-2.081-.475l-5.439,3.5a1.666,1.666,0,0,0-.438.438.19.19,0,0,0-.073.146l-.767,1.46a.954.954,0,0,0,.036.986,1,1,0,0,0,.876.438l1.606-.073a.463.463,0,0,0,.219-.036,1.093,1.093,0,0,0,.292-.146.914.914,0,0,0,.256-.146l5.439-3.468a1.617,1.617,0,0,0,.657-.949,1.854,1.854,0,0,0-.219-1.059Zm-1.059.876c-.036.036-.036.109-.109.146l-4.819,3.066-.657-1.022,4.819-3.066c.036,0,.073,0,.073-.037a.245.245,0,0,1,.292.11l.365.621C656.462,339.178,656.462,339.251,656.426,339.324Z",
    transform: "translate(-636.713 -331.114)",
    fill: "#3208ff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualCreateOption4);
export default __webpack_public_path__ + "static/media/manual_create_option4.e03d7b26e8d086c15001c55c60871fef.svg";
export { ForwardRef as ReactComponent };